// @flow
import React from "react";
import ReactDOM from "react-dom";
import "sanitize.css/sanitize.css";
import Rollbar from "rollbar/dist/rollbar.umd.min";
import rollbarConfig from "./etc/rollbar";
import "./index.css";
import App from "./components";
import registerServiceWorker from "./helpers/registerServiceWorker";

// if (process.env.NODE_ENV !== "development") {
window.Rollbar = Rollbar.init(rollbarConfig);
// }

const mountNode = document.getElementById("root");
if (mountNode) ReactDOM.render(<App />, mountNode);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js